import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-purple-700 to-purple-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Followers Hub</h3>
            <p className="text-gray-400 mb-4">
              Your trusted platform for buying real social media followers across all major platforms.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Platforms</h4>
            <ul className="space-y-2">
              <li><Link to="/packages?platform=facebook" className="text-gray-400 hover:text-white">Facebook</Link></li>
              <li><Link to="/packages?platform=instagram" className="text-gray-400 hover:text-white">Instagram</Link></li>
              <li><Link to="/packages?platform=youtube" className="text-gray-400 hover:text-white">YouTube</Link></li>
              <li><Link to="/packages?platform=tiktok" className="text-gray-400 hover:text-white">TikTok</Link></li>
              <li><Link to="/packages?platform=twitter" className="text-gray-400 hover:text-white">Twitter</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-white">Terms of Service</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              <li><Link to="/faq" className="text-gray-400 hover:text-white">FAQ</Link></li>
              <li><Link to="/support" className="text-gray-400 hover:text-white">Support</Link></li>
              <li><Link to="/dashboard" className="text-gray-400 hover:text-white">Dashboard</Link></li>
              <li><Link to="/orders" className="text-gray-400 hover:text-white">My Orders</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 Followers Hub. All rights reserved. | Built with React & Node.js
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
